<project-navigation
  [headerTitle]="'projectNavigation.title_copy_project'"
  [headerText]="'projectNavigation.text_copy_project'"
  [model]="model"
  [submitEnabled]="submitEnabled"
  [actionButtonLabel]="'global.label.save'"
  [visibleFeatures]="{
    compositeCheckBox: false,
    pinnedProjects: false,
    recentlyUsedProjects: false,
    history: true,
    projectActionsMenu: true,
    projectGroupContextMenu: false,
    newConfigurationGroupBtn: true,
    newFolderBtn: true,
    dialogSearch: true,
    tabs: true,
    breadcrumbs: true,
  }"
  [itemToMoveOrCopy]="itemToCopy"
  (submitEnabledChanged)="updateSubmitEnabled()"
  (actionBtnClick)="copyProject()"
  (cancel)="cancel()"
></project-navigation>
